import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { reportUnexpectedError } from '../../../lib/reportError'
import type { LoyaltyConfig } from './useLoyaltyConfig'

interface SaveLoyaltyConfigResult {
  success: boolean
  id?: string
  error?: string
}

async function saveLoyaltyConfig(config: LoyaltyConfig): Promise<SaveLoyaltyConfigResult> {
  const { data, error } = await supabase.functions.invoke<SaveLoyaltyConfigResult>('save-loyalty-config', {
    body: {
      earningMethod: config.earningMethod,
      amountPerStamp: config.amountPerStamp,
      stampTarget: config.stampTarget,
      completionRewardItemId: config.completionRewardItemId,
      completionCardIcon: config.completionCardIcon,
      milestones: config.milestones,
    },
  })
  if (error) {
    reportUnexpectedError(error)
    throw error
  }
  if (!data?.success) {
    const failure = new Error(data?.error ?? 'save_failed')
    reportUnexpectedError(failure)
    throw failure
  }
  return data
}

export function useSaveLoyaltyConfig() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: saveLoyaltyConfig,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['loyalty-config'] }),
  })
}